"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schedule = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _basicStyledText = _interopRequireDefault(require("../basicStyledText"));
var _scheduleUtils = require("./scheduleUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Schedule = props => {
  const {
    schedule,
    t
  } = props;
  function displayTheme(item) {
    if ('theme' in item) {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "con-text__xs--margin-bottom-2"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "con-basic-styling-bold"
      }, t('Pages.Schedule.Theme')), " ", item.theme);
    }
  }
  function displayChair(item) {
    if ('chair' in item) {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "con-text__xs--margin-bottom-2"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "con-basic-styling-bold"
      }, t('Pages.Schedule.Chair')), " ", item.chair);
    }
  }
  function displayAbstract(item) {
    if ('abstract' in item) {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "con-text__xs"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "con-basic-styling-bold"
      }, t('Pages.Schedule.Abstract')), " ", item.abstract);
    }
  }
  const emcee = {
    "text": "Emcee: ",
    "bold": true,
    "italic": false
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-schedule"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "con-schedule__list"
  }, schedule.map(item => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "con-schedule__list--item",
      id: "schedule-item-".concat(item.id),
      key: item.id
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "con-bullet-point"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading__xs--bold"
    }, item.time), /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading-schedule__xs--bold"
    }, item.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading-schedule__xs--societal"
    }, item.societalTitle), /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading-schedule__xs--technical"
    }, item.technicalTitle), displayTheme(item), displayChair(item), /*#__PURE__*/_react.default.createElement("p", {
      className: "con-heading-schedule__xs--bold"
    }, item.title2), item.speakers.map(speakerObject => {
      return /*#__PURE__*/_react.default.createElement("p", {
        key: speakerObject.id,
        className: "con-text__xs--margin-bottom-1"
      }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
        item: speakerObject
      }));
    }), displayAbstract(item), item.emcee != null ? /*#__PURE__*/_react.default.createElement("div", {
      className: "con-text__xs"
    }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
      item: emcee
    }), /*#__PURE__*/_react.default.createElement("p", null, item.emcee)) : null, item.dragons != null ? (0, _scheduleUtils.renderDragons)(item.dragons) : null, item.startups != null ? (0, _scheduleUtils.renderStartups)(item.startups) : null);
  })));
};
exports.Schedule = Schedule;
Schedule.propTypes = {
  schedule: _propTypes.default.array,
  t: _propTypes.default.func
};